export enum Environments {
    LOCAL,
    TEST,
    PROD
}
